// AUTO-GENERATED from KYT PDF catalogue. Do not edit by hand.
// Kaynak: SON YENI.pdf — tüm proje görselleri, isimleri ve açıklamaları.

export const projects = [
  {
    "slug": "cezayir-stadyum-kompleksi",
    "name": "Cezayir 50.000 Kişilik Stadyum Kompleksi",
    "category": "stadyum",
    "firma": "Atlas İnşaat",
    "bedel": "22.000.000 $",
    "is": "Stadium Hacine ait Ahmet — 50.000 Kişilik / Tizi Ouzou",
    "tarih": "2021",
    "location": "Tizi Ouzou, Cezayir",
    "featured": 1,
    "images": [
      "/projects/cezayir-stadyum-kompleksi/cover.jpg",
      "/projects/cezayir-stadyum-kompleksi/g1.jpg",
      "/projects/cezayir-stadyum-kompleksi/g2.jpg",
      "/projects/cezayir-stadyum-kompleksi/g3.jpg"
    ],
    "cover": "/projects/cezayir-stadyum-kompleksi/cover.jpg"
  },
  {
    "slug": "kocaeli-kultur-sanat-merkezi",
    "name": "Kocaeli Kültür Sanat Merkezi",
    "category": "sosyal",
    "firma": "Alkataş İnşaat",
    "bedel": "4.000.000 $",
    "is": "Kocaeli Kültür Merkezi A.G - O.G - Z.A Elektrik İşleri",
    "tarih": "2018/2019",
    "location": "Kocaeli",
    "featured": 2,
    "images": [
      "/projects/kocaeli-kultur-sanat-merkezi/cover.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g1.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g2.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g3.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g4.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g5.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g6.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g7.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g8.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g9.jpg",
      "/projects/kocaeli-kultur-sanat-merkezi/g10.jpg"
    ],
    "cover": "/projects/kocaeli-kultur-sanat-merkezi/cover.jpg"
  },
  {
    "slug": "cezayir-hastane-otel-otopark",
    "name": "Cezayir Hastane, Otel ve Otopark Kompleksi",
    "category": "saglik",
    "firma": "Atlas İnşaat",
    "bedel": "7.500.000 $",
    "is": "Cezayir Hastane, Otel ve Otopark Kompleksi Elektrik İşleri",
    "tarih": "2019",
    "location": "Cezayir",
    "featured": 3,
    "images": [
      "/projects/cezayir-hastane-otel-otopark/cover.jpg",
      "/projects/cezayir-hastane-otel-otopark/g1.jpg",
      "/projects/cezayir-hastane-otel-otopark/g2.jpg",
      "/projects/cezayir-hastane-otel-otopark/g3.jpg"
    ],
    "cover": "/projects/cezayir-hastane-otel-otopark/cover.jpg"
  },
  {
    "slug": "bilisim-vadisi-2-etap",
    "name": "Bilişim Vadisi Kuluçka Binaları ve Kongre Merkezi 2. Etap",
    "category": "egitim",
    "firma": "Haldız İnşaat",
    "bedel": "1.100.000 $",
    "is": "Bilişim Vadisi Kuluçka Binaları ve Kongre Merkezi 2. Etap AG-OG Elektrik İşleri",
    "tarih": "2017",
    "location": "Kocaeli",
    "featured": 4,
    "images": [
      "/projects/bilisim-vadisi-2-etap/cover.jpg",
      "/projects/bilisim-vadisi-2-etap/g1.jpg",
      "/projects/bilisim-vadisi-2-etap/g2.jpg",
      "/projects/bilisim-vadisi-2-etap/g3.jpg"
    ],
    "cover": "/projects/bilisim-vadisi-2-etap/cover.jpg"
  },
  {
    "slug": "acibadem-hastanesi",
    "name": "Acıbadem Hastanesi",
    "category": "saglik",
    "firma": "Acıbadem Hastanesi",
    "bedel": "550.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2006",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/acibadem-hastanesi/cover.jpg",
      "/projects/acibadem-hastanesi/g1.jpg",
      "/projects/acibadem-hastanesi/g2.jpg",
      "/projects/acibadem-hastanesi/g3.jpg",
      "/projects/acibadem-hastanesi/g4.jpg",
      "/projects/acibadem-hastanesi/g5.jpg"
    ],
    "cover": "/projects/acibadem-hastanesi/cover.jpg"
  },
  {
    "slug": "sakarya-egitim-arastirma-hastanesi",
    "name": "Sakarya 400 Yataklı Eğitim ve Araştırma Hastanesi",
    "category": "saglik",
    "firma": "Toki",
    "bedel": "4.150.000 USD",
    "is": "Sakarya 400 Yataklı Devlet Hastanesi Genel Elektrik İşleri",
    "tarih": "2011",
    "location": "Sakarya",
    "featured": 0,
    "images": [
      "/projects/sakarya-egitim-arastirma-hastanesi/cover.jpg",
      "/projects/sakarya-egitim-arastirma-hastanesi/g1.jpg",
      "/projects/sakarya-egitim-arastirma-hastanesi/g2.jpg",
      "/projects/sakarya-egitim-arastirma-hastanesi/g3.jpg",
      "/projects/sakarya-egitim-arastirma-hastanesi/g4.jpg",
      "/projects/sakarya-egitim-arastirma-hastanesi/g5.jpg"
    ],
    "cover": "/projects/sakarya-egitim-arastirma-hastanesi/cover.jpg"
  },
  {
    "slug": "rize-egitim-arastirma-hastanesi",
    "name": "Rize 250 Yataklı Eğitim ve Araştırma Hastanesi",
    "category": "saglik",
    "firma": "Toki",
    "bedel": "2.980.000 USD",
    "is": "Rize 250 Yataklı Devlet Hastanesi Genel Elektrik İşleri",
    "tarih": "2010",
    "location": "Rize",
    "featured": 0,
    "images": [
      "/projects/rize-egitim-arastirma-hastanesi/cover.jpg",
      "/projects/rize-egitim-arastirma-hastanesi/g1.jpg",
      "/projects/rize-egitim-arastirma-hastanesi/g2.jpg",
      "/projects/rize-egitim-arastirma-hastanesi/g3.jpg"
    ],
    "cover": "/projects/rize-egitim-arastirma-hastanesi/cover.jpg"
  },
  {
    "slug": "golcuk-devlet-hastanesi",
    "name": "Gölcük Devlet Hastanesi",
    "category": "saglik",
    "firma": "Gölcük Devlet Hastanesi",
    "bedel": "322.000 USD",
    "is": "400 Kva ve 70 Yataklı Hastane Genel Elektrik İşleri",
    "tarih": "2006",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/golcuk-devlet-hastanesi/cover.jpg",
      "/projects/golcuk-devlet-hastanesi/g1.jpg",
      "/projects/golcuk-devlet-hastanesi/g2.jpg",
      "/projects/golcuk-devlet-hastanesi/g3.jpg"
    ],
    "cover": "/projects/golcuk-devlet-hastanesi/cover.jpg"
  },
  {
    "slug": "medicalpark-hastanesi",
    "name": "Medicalpark Hastanesi",
    "category": "saglik",
    "firma": "Kavanlar İnşaat",
    "bedel": "7.225.000 USD",
    "is": "Sembol AVM ve Medical Park Hastane Genel Elektrik İşleri",
    "tarih": "2016",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/medicalpark-hastanesi/cover.jpg",
      "/projects/medicalpark-hastanesi/g1.jpg",
      "/projects/medicalpark-hastanesi/g2.jpg"
    ],
    "cover": "/projects/medicalpark-hastanesi/cover.jpg"
  },
  {
    "slug": "turkiye-hastanesi",
    "name": "Türkiye Hastanesi",
    "category": "saglik",
    "firma": "İhlas Holding",
    "bedel": "397.640 USD",
    "is": "Türkiye Hastanesi Kadın Doğum-Çocuk Ünitesi ZA-AG-OG Elektrik İşleri",
    "tarih": "2017/2018",
    "location": "İstanbul",
    "featured": 0,
    "images": [
      "/projects/turkiye-hastanesi/cover.jpg",
      "/projects/turkiye-hastanesi/g1.jpg",
      "/projects/turkiye-hastanesi/g2.jpg",
      "/projects/turkiye-hastanesi/g3.jpg"
    ],
    "cover": "/projects/turkiye-hastanesi/cover.jpg"
  },
  {
    "slug": "akyazi-devlet-hastanesi",
    "name": "Akyazı 100 Yataklı Devlet Hastanesi",
    "category": "saglik",
    "firma": "Arter İnşaat",
    "bedel": "1.000.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2008",
    "location": "Sakarya",
    "featured": 0,
    "images": [
      "/projects/akyazi-devlet-hastanesi/cover.jpg",
      "/projects/akyazi-devlet-hastanesi/g1.jpg",
      "/projects/akyazi-devlet-hastanesi/g2.jpg",
      "/projects/akyazi-devlet-hastanesi/g3.jpg"
    ],
    "cover": "/projects/akyazi-devlet-hastanesi/cover.jpg"
  },
  {
    "slug": "dedeman-otel",
    "name": "Dedeman Otel",
    "category": "turizm",
    "firma": "Haldız İnşaat",
    "bedel": "4.350.000 USD + 680.000 USD",
    "is": "Nuh AVM - Dedeman Otel ve AVM Genel Elektrik İşleri",
    "tarih": "2012-2013",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/dedeman-otel/cover.jpg",
      "/projects/dedeman-otel/g1.jpg",
      "/projects/dedeman-otel/g2.jpg",
      "/projects/dedeman-otel/g3.jpg",
      "/projects/dedeman-otel/g4.jpg",
      "/projects/dedeman-otel/g5.jpg"
    ],
    "cover": "/projects/dedeman-otel/cover.jpg"
  },
  {
    "slug": "bayramoglu-resort",
    "name": "Bayramoğlu Resort",
    "category": "turizm",
    "firma": "Bayramoğlu Resort",
    "bedel": "800.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2016",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/bayramoglu-resort/cover.jpg",
      "/projects/bayramoglu-resort/g1.jpg",
      "/projects/bayramoglu-resort/g2.jpg",
      "/projects/bayramoglu-resort/g3.jpg",
      "/projects/bayramoglu-resort/g4.jpg",
      "/projects/bayramoglu-resort/g5.jpg"
    ],
    "cover": "/projects/bayramoglu-resort/cover.jpg"
  },
  {
    "slug": "coca-cola",
    "name": "Coca Cola C.O",
    "category": "endustriyel",
    "firma": "Coca Cola C.O",
    "bedel": "754.000 USD + 550.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2008",
    "location": "Erbil/Irak — Kabil/Afganistan",
    "featured": 0,
    "images": [
      "/projects/coca-cola/cover.jpg",
      "/projects/coca-cola/g1.jpg",
      "/projects/coca-cola/g2.jpg",
      "/projects/coca-cola/g3.jpg",
      "/projects/coca-cola/g4.jpg",
      "/projects/coca-cola/g5.jpg"
    ],
    "cover": "/projects/coca-cola/cover.jpg"
  },
  {
    "slug": "tofas",
    "name": "Tofaş Türk Otomobil Fabrikası A.Ş.",
    "category": "endustriyel",
    "firma": "Tofaş Türk Oto. Fab. A.Ş.",
    "bedel": "610.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2007",
    "location": "Bursa",
    "featured": 0,
    "images": [
      "/projects/tofas/cover.jpg",
      "/projects/tofas/g1.jpg",
      "/projects/tofas/g2.jpg",
      "/projects/tofas/g3.jpg",
      "/projects/tofas/g4.jpg",
      "/projects/tofas/g5.jpg"
    ],
    "cover": "/projects/tofas/cover.jpg"
  },
  {
    "slug": "mercedes-benz",
    "name": "Mercedes Benz A.Ş.",
    "category": "endustriyel",
    "firma": "Mercedes Benz A.Ş.",
    "bedel": "370.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2007",
    "location": "Aksaray",
    "featured": 0,
    "images": [
      "/projects/mercedes-benz/cover.jpg",
      "/projects/mercedes-benz/g1.jpg",
      "/projects/mercedes-benz/g2.jpg",
      "/projects/mercedes-benz/g3.jpg",
      "/projects/mercedes-benz/g4.jpg",
      "/projects/mercedes-benz/g5.jpg"
    ],
    "cover": "/projects/mercedes-benz/cover.jpg"
  },
  {
    "slug": "frito-lay",
    "name": "Frito-Lay Gıda Sanayi",
    "category": "endustriyel",
    "firma": "Frito-Lay Gıda San.",
    "bedel": "115.000 USD",
    "is": "Depolama, Ofis, Yemekhane Genel Elektrik İşleri",
    "tarih": "2004",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/frito-lay/cover.jpg",
      "/projects/frito-lay/g1.jpg",
      "/projects/frito-lay/g2.jpg",
      "/projects/frito-lay/g3.jpg",
      "/projects/frito-lay/g4.jpg",
      "/projects/frito-lay/g5.jpg"
    ],
    "cover": "/projects/frito-lay/cover.jpg"
  },
  {
    "slug": "izfas-fuar-merkezi",
    "name": "İzfaş Uluslararası Fuar Merkezi",
    "category": "endustriyel",
    "firma": "İZFAŞ Uluslararası Fuar Merkezi",
    "bedel": "625.000 USD",
    "is": "3x1600 KVA Trafo ve 30.000 m² Elektrik İşleri",
    "tarih": "2004",
    "location": "İzmir",
    "featured": 0,
    "images": [
      "/projects/izfas-fuar-merkezi/cover.jpg",
      "/projects/izfas-fuar-merkezi/g1.jpg",
      "/projects/izfas-fuar-merkezi/g2.jpg",
      "/projects/izfas-fuar-merkezi/g3.jpg",
      "/projects/izfas-fuar-merkezi/g4.jpg",
      "/projects/izfas-fuar-merkezi/g5.jpg"
    ],
    "cover": "/projects/izfas-fuar-merkezi/cover.jpg"
  },
  {
    "slug": "msb-helikopter-ussu",
    "name": "M.S.B Helikopter Üssü",
    "category": "endustriyel",
    "firma": "M.S.B Helikopter Üssü",
    "bedel": "270.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2003",
    "location": "Çanakkale",
    "featured": 0,
    "images": [
      "/projects/msb-helikopter-ussu/cover.jpg",
      "/projects/msb-helikopter-ussu/g1.jpg",
      "/projects/msb-helikopter-ussu/g2.jpg",
      "/projects/msb-helikopter-ussu/g3.jpg",
      "/projects/msb-helikopter-ussu/g4.jpg",
      "/projects/msb-helikopter-ussu/g5.jpg"
    ],
    "cover": "/projects/msb-helikopter-ussu/cover.jpg"
  },
  {
    "slug": "sasa-inegol-tesisi",
    "name": "Sasa İnegöl Tesisi",
    "category": "endustriyel",
    "firma": "Sasa İnegöl Tesisi",
    "bedel": "140.000 USD",
    "is": "800 m² Genel Elektrik İşleri",
    "tarih": "2003",
    "location": "Bursa",
    "featured": 0,
    "images": [
      "/projects/sasa-inegol-tesisi/cover.jpg",
      "/projects/sasa-inegol-tesisi/g1.jpg",
      "/projects/sasa-inegol-tesisi/g2.jpg",
      "/projects/sasa-inegol-tesisi/g3.jpg",
      "/projects/sasa-inegol-tesisi/g4.jpg",
      "/projects/sasa-inegol-tesisi/g5.jpg"
    ],
    "cover": "/projects/sasa-inegol-tesisi/cover.jpg"
  },
  {
    "slug": "enerjisa",
    "name": "Enerjisa A.Ş.",
    "category": "endustriyel",
    "firma": "Enerjisa A.Ş.",
    "bedel": "120.000 USD + 210.000 USD",
    "is": "STG Güvenlik, Kum Binası ve Çevre Aydınlatma ile Genel Müdürlük Binası Elektrik İşleri",
    "tarih": "2008",
    "location": "Adana / Kocaeli / Çanakkale",
    "featured": 0,
    "images": [
      "/projects/enerjisa/cover.jpg",
      "/projects/enerjisa/g1.jpg",
      "/projects/enerjisa/g2.jpg",
      "/projects/enerjisa/g3.jpg",
      "/projects/enerjisa/g4.jpg",
      "/projects/enerjisa/g5.jpg",
      "/projects/enerjisa/g6.jpg"
    ],
    "cover": "/projects/enerjisa/cover.jpg"
  },
  {
    "slug": "yalova-elyaf-fabrikasi",
    "name": "Yalova Elyaf Fabrikası",
    "category": "endustriyel",
    "firma": "Yalova Elyaf Fabrikası",
    "bedel": "180.000 USD + 280.000 USD",
    "is": "İplik Fabrikası 3 / Endüstriyel Su Arıtma Tesisi",
    "tarih": "1993",
    "location": "Yalova",
    "featured": 0,
    "images": [
      "/projects/yalova-elyaf-fabrikasi/cover.jpg",
      "/projects/yalova-elyaf-fabrikasi/g1.jpg",
      "/projects/yalova-elyaf-fabrikasi/g2.jpg",
      "/projects/yalova-elyaf-fabrikasi/g3.jpg",
      "/projects/yalova-elyaf-fabrikasi/g4.jpg",
      "/projects/yalova-elyaf-fabrikasi/g5.jpg"
    ],
    "cover": "/projects/yalova-elyaf-fabrikasi/cover.jpg"
  },
  {
    "slug": "ingersoll-rand",
    "name": "Ingersoll Rand",
    "category": "endustriyel",
    "firma": "Ingersoll Rand",
    "bedel": "2.400.000 USD",
    "is": "6 MVA O.G Tesisi - Fabrika Aydınlatma Projesi",
    "tarih": "2002",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/ingersoll-rand/cover.jpg",
      "/projects/ingersoll-rand/g1.jpg",
      "/projects/ingersoll-rand/g2.jpg",
      "/projects/ingersoll-rand/g3.jpg",
      "/projects/ingersoll-rand/g4.jpg",
      "/projects/ingersoll-rand/g5.jpg"
    ],
    "cover": "/projects/ingersoll-rand/cover.jpg"
  },
  {
    "slug": "tesco-kipa-avm",
    "name": "Tesco Kipa Alışveriş Merkezi",
    "category": "avm",
    "firma": "Tesco Kipa",
    "bedel": "970.000 USD + 1.485.000 USD",
    "is": "Market ve Mağazalar Genel Elektrik İşleri",
    "tarih": "2007",
    "location": "Kırıkkale / Edirne",
    "featured": 0,
    "images": [
      "/projects/tesco-kipa-avm/cover.jpg",
      "/projects/tesco-kipa-avm/g1.jpg",
      "/projects/tesco-kipa-avm/g2.jpg",
      "/projects/tesco-kipa-avm/g3.jpg",
      "/projects/tesco-kipa-avm/g4.jpg",
      "/projects/tesco-kipa-avm/g5.jpg"
    ],
    "cover": "/projects/tesco-kipa-avm/cover.jpg"
  },
  {
    "slug": "carrefoursa-avm",
    "name": "Carrefoursa Alışveriş Merkezi",
    "category": "avm",
    "firma": "Carrefoursa",
    "bedel": "100.000 USD",
    "is": "34.5 Kv Enerji Nakil Hattı",
    "tarih": "1999",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/carrefoursa-avm/cover.jpg",
      "/projects/carrefoursa-avm/g1.jpg",
      "/projects/carrefoursa-avm/g2.jpg",
      "/projects/carrefoursa-avm/g3.jpg"
    ],
    "cover": "/projects/carrefoursa-avm/cover.jpg"
  },
  {
    "slug": "tansas-avm",
    "name": "Tansaş Alışveriş Merkezi",
    "category": "avm",
    "firma": "Tansaş",
    "bedel": "450.000 USD",
    "is": "Market ve Mağazalar Genel Elektrik İşleri",
    "tarih": "2000",
    "location": "İzmir",
    "featured": 0,
    "images": [
      "/projects/tansas-avm/cover.jpg",
      "/projects/tansas-avm/g1.jpg",
      "/projects/tansas-avm/g2.jpg",
      "/projects/tansas-avm/g3.jpg",
      "/projects/tansas-avm/g4.jpg",
      "/projects/tansas-avm/g5.jpg"
    ],
    "cover": "/projects/tansas-avm/cover.jpg"
  },
  {
    "slug": "dolphin-avm",
    "name": "Dolphin Alışveriş Merkezi",
    "category": "avm",
    "firma": "Dolphin Alışveriş Merkezi",
    "bedel": "1.050.000 USD",
    "is": "2x1600 Kva Trafo ve 40.000 m² Kapalı Alan Alışveriş Merkezi",
    "tarih": "2004",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/dolphin-avm/cover.jpg",
      "/projects/dolphin-avm/g1.jpg",
      "/projects/dolphin-avm/g2.jpg",
      "/projects/dolphin-avm/g3.jpg",
      "/projects/dolphin-avm/g4.jpg",
      "/projects/dolphin-avm/g5.jpg"
    ],
    "cover": "/projects/dolphin-avm/cover.jpg"
  },
  {
    "slug": "arasta-park-avm",
    "name": "Arasta Park Alışveriş Merkezi",
    "category": "avm",
    "firma": "İLSA Beton",
    "bedel": "846.000 USD",
    "is": "Arasta Park AVM Elektrik İşçilik Hizmeti",
    "tarih": "2007",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/arasta-park-avm/cover.jpg",
      "/projects/arasta-park-avm/g1.jpg",
      "/projects/arasta-park-avm/g2.jpg",
      "/projects/arasta-park-avm/g3.jpg"
    ],
    "cover": "/projects/arasta-park-avm/cover.jpg"
  },
  {
    "slug": "symbol-medicalpark",
    "name": "Symbol - Medicalpark",
    "category": "avm",
    "firma": "Kavanlar İnşaat",
    "bedel": "7.225.000 USD",
    "is": "Sembol AVM ve Medical Park Hastane Genel Elektrik İşleri",
    "tarih": "2016",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/symbol-medicalpark/cover.jpg",
      "/projects/symbol-medicalpark/g1.jpg",
      "/projects/symbol-medicalpark/g2.jpg"
    ],
    "cover": "/projects/symbol-medicalpark/cover.jpg"
  },
  {
    "slug": "istanbul-unv-ulastirma-myo",
    "name": "İstanbul Ünv. Ulaştırma M.Y.O",
    "category": "egitim",
    "firma": "İstanbul Üniversitesi",
    "bedel": "210.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2005",
    "location": "İstanbul",
    "featured": 0,
    "images": [
      "/projects/istanbul-unv-ulastirma-myo/cover.jpg",
      "/projects/istanbul-unv-ulastirma-myo/g1.jpg",
      "/projects/istanbul-unv-ulastirma-myo/g2.jpg",
      "/projects/istanbul-unv-ulastirma-myo/g3.jpg",
      "/projects/istanbul-unv-ulastirma-myo/g4.jpg",
      "/projects/istanbul-unv-ulastirma-myo/g5.jpg"
    ],
    "cover": "/projects/istanbul-unv-ulastirma-myo/cover.jpg"
  },
  {
    "slug": "ilka-plastik",
    "name": "İlka Plastik",
    "category": "egitim",
    "firma": "İlka Plastik A.Ş.",
    "bedel": "420.000 USD",
    "is": "Kampüs İnşaatı Genel Elektrik İşleri",
    "tarih": "1995",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/ilka-plastik/cover.jpg",
      "/projects/ilka-plastik/g1.jpg",
      "/projects/ilka-plastik/g2.jpg",
      "/projects/ilka-plastik/g3.jpg"
    ],
    "cover": "/projects/ilka-plastik/cover.jpg"
  },
  {
    "slug": "bilisim-vadisi-1-etap",
    "name": "Bilişim Vadisi Kuluçka Binaları ve Kongre Merkezi 1. Etap",
    "category": "egitim",
    "firma": "Alkataş İnşaat",
    "bedel": "1.700.000 $",
    "is": "Bilişim Vadisi Kuluçka Binaları ve Kongre Merkezi 1. Etap AG-OG Elektrik İşleri",
    "tarih": "2017/2018",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/bilisim-vadisi-1-etap/cover.jpg",
      "/projects/bilisim-vadisi-1-etap/g1.jpg",
      "/projects/bilisim-vadisi-1-etap/g2.jpg",
      "/projects/bilisim-vadisi-1-etap/g3.jpg"
    ],
    "cover": "/projects/bilisim-vadisi-1-etap/cover.jpg"
  },
  {
    "slug": "f16-simulator-binalari",
    "name": "F16 Simülatör Binaları",
    "category": "sosyal",
    "firma": "M.S.B",
    "bedel": "4.150.000 USD + 930.000 USD",
    "is": "Genel Elektrik İşleri (Balıkesir, Bandırma, Ankara, Merzifon, Diyarbakır)",
    "tarih": "2011-2012",
    "location": "Türkiye Geneli",
    "featured": 0,
    "images": [
      "/projects/f16-simulator-binalari/cover.jpg",
      "/projects/f16-simulator-binalari/g1.jpg",
      "/projects/f16-simulator-binalari/g2.jpg",
      "/projects/f16-simulator-binalari/g3.jpg",
      "/projects/f16-simulator-binalari/g4.jpg"
    ],
    "cover": "/projects/f16-simulator-binalari/cover.jpg"
  },
  {
    "slug": "havelsan-pendik",
    "name": "Havelsan Pendik Hizmet Binası",
    "category": "sosyal",
    "firma": "Havelsan",
    "bedel": "650.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2010",
    "location": "İstanbul",
    "featured": 0,
    "images": [
      "/projects/havelsan-pendik/cover.jpg",
      "/projects/havelsan-pendik/g1.jpg",
      "/projects/havelsan-pendik/g2.jpg",
      "/projects/havelsan-pendik/g3.jpg"
    ],
    "cover": "/projects/havelsan-pendik/cover.jpg"
  },
  {
    "slug": "teknosa-lojistik",
    "name": "Teknosa Lojistik",
    "category": "sosyal",
    "firma": "Teknosa Lojistik",
    "bedel": "642.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "2007",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/teknosa-lojistik/cover.jpg",
      "/projects/teknosa-lojistik/g1.jpg",
      "/projects/teknosa-lojistik/g2.jpg",
      "/projects/teknosa-lojistik/g3.jpg",
      "/projects/teknosa-lojistik/g4.jpg",
      "/projects/teknosa-lojistik/g5.jpg"
    ],
    "cover": "/projects/teknosa-lojistik/cover.jpg"
  },
  {
    "slug": "und-as",
    "name": "Und A.Ş.",
    "category": "sosyal",
    "firma": "Und A.Ş.",
    "bedel": "530.000 USD",
    "is": "Und Gürbulak Sınır Kapısı Genel Elektrik İşleri",
    "tarih": "2003",
    "location": "Gürbulak",
    "featured": 0,
    "images": [
      "/projects/und-as/cover.jpg",
      "/projects/und-as/g1.jpg",
      "/projects/und-as/g2.jpg",
      "/projects/und-as/g3.jpg",
      "/projects/und-as/g4.jpg"
    ],
    "cover": "/projects/und-as/cover.jpg"
  },
  {
    "slug": "ipekyol-tekstil",
    "name": "İpekyol Tekstil A.Ş.",
    "category": "sosyal",
    "firma": "İpekyol Tekstil A.Ş.",
    "bedel": "275.000 USD",
    "is": "İpekyol Tekstil Yönetim Binası Elektrik İşleri",
    "tarih": "2000",
    "location": "İstanbul",
    "featured": 0,
    "images": [
      "/projects/ipekyol-tekstil/cover.jpg",
      "/projects/ipekyol-tekstil/g1.jpg",
      "/projects/ipekyol-tekstil/g2.jpg",
      "/projects/ipekyol-tekstil/g3.jpg"
    ],
    "cover": "/projects/ipekyol-tekstil/cover.jpg"
  },
  {
    "slug": "kocaeli-sanayi-odasi",
    "name": "Kocaeli Sanayi Odası",
    "category": "sosyal",
    "firma": "Kocaeli Sanayi Odası",
    "bedel": "190.000 USD",
    "is": "Sosyal Tesis ve Hizmet Binası Genel Elektrik İşleri",
    "tarih": "1994",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/kocaeli-sanayi-odasi/cover.jpg",
      "/projects/kocaeli-sanayi-odasi/g1.jpg",
      "/projects/kocaeli-sanayi-odasi/g2.jpg",
      "/projects/kocaeli-sanayi-odasi/g3.jpg",
      "/projects/kocaeli-sanayi-odasi/g4.jpg"
    ],
    "cover": "/projects/kocaeli-sanayi-odasi/cover.jpg"
  },
  {
    "slug": "uskudar-belediyesi",
    "name": "Üsküdar Belediyesi Ek Hizmet Binası",
    "category": "sosyal",
    "firma": "Alkataş İnşaat",
    "bedel": "1.700.000 $",
    "is": "Üsküdar Belediyesi Ek Hizmet Binası AG-OG Elektrik İşleri",
    "tarih": "2015/2017",
    "location": "İstanbul",
    "featured": 0,
    "images": [
      "/projects/uskudar-belediyesi/cover.jpg",
      "/projects/uskudar-belediyesi/g1.jpg",
      "/projects/uskudar-belediyesi/g2.jpg",
      "/projects/uskudar-belediyesi/g3.jpg"
    ],
    "cover": "/projects/uskudar-belediyesi/cover.jpg"
  },
  {
    "slug": "adana-stadyumu",
    "name": "Adana 33.000 Kişilik Stadyum",
    "category": "stadyum",
    "firma": "Alkataş İnşaat",
    "bedel": "890.000 $",
    "is": "Adana 33.000 Kişilik Stadyum Elektrik İşleri",
    "tarih": "2018/2019",
    "location": "Adana",
    "featured": 0,
    "images": [
      "/projects/adana-stadyumu/cover.jpg",
      "/projects/adana-stadyumu/g1.jpg",
      "/projects/adana-stadyumu/g2.jpg",
      "/projects/adana-stadyumu/g3.jpg"
    ],
    "cover": "/projects/adana-stadyumu/cover.jpg"
  },
  {
    "slug": "atasehir-konutlari",
    "name": "Ataşehir Konutları",
    "category": "konut",
    "firma": "Tekfen - Alarko",
    "bedel": "500.000 USD + 420.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "1996",
    "location": "İstanbul",
    "featured": 0,
    "images": [
      "/projects/atasehir-konutlari/cover.jpg"
    ],
    "cover": "/projects/atasehir-konutlari/cover.jpg"
  },
  {
    "slug": "bahcekent-konaklari",
    "name": "Bahçekent Konakları",
    "category": "konut",
    "firma": "Bahçekent Konakları",
    "bedel": "350.000 USD",
    "is": "Genel Elektrik İşleri",
    "tarih": "1999",
    "location": "Kocaeli",
    "featured": 0,
    "images": [
      "/projects/bahcekent-konaklari/cover.jpg",
      "/projects/bahcekent-konaklari/g1.jpg",
      "/projects/bahcekent-konaklari/g2.jpg",
      "/projects/bahcekent-konaklari/g3.jpg",
      "/projects/bahcekent-konaklari/g4.jpg",
      "/projects/bahcekent-konaklari/g5.jpg"
    ],
    "cover": "/projects/bahcekent-konaklari/cover.jpg"
  }
];

export const getProject = (slug) => projects.find((p) => p.slug === slug);
export const featuredProjects = projects.filter((p) => p.featured > 0).sort((a,b)=>a.featured-b.featured);
